/*
    A container for buttons to perform several common pre-built actions for a trip:

    - remove trip
    - cancel trip
    - mark trip as no show

    - run boarding announcement
    - run lane change announcement
    - run delay announcement
    - run cancelled announcement
*/

import React from "react";

import MainContext from "../MainContext";

import ReasonForm from "../Forms/ReasonForm";

import { 
    runDelayedAnnouncement,
    runCancelledAnnouncement,
    runBoardingAnnouncement,
    runLaneChangeAnnouncement,
    hideTrip,
    cancelTrip,
    noShowTrip
} from "../Requests/BusOpsRequests";

export default class BusOpsStatusAndAnnouncements extends React.Component {

    static contextType = MainContext;

    state = { 
        reasonFormOpen: false,
        reasonCancel: false,
        reasonNoShow: false
    };

    runHide = () => {
        const run = window.confirm("Are you sure you want to hide this trip?");
        if(run){
            // we don't run any change on the data from the back end
            // instead we just remove the record from the view of this particular user

            // remove it from list?
            // add a record to localstorage identifying this record
            // on data load, filter out this record from being displayed

            this.props.removeTrip(this.props.containerIndex, true);
            this.props.refresh();

            // const request = () => hideTrip(this.props.data);
            // const then = ({data}) => {
            //     this.context.sendNotification(!data, data ? "Trip has been hidden": "Error hiding trip");
            //     // need to update the current record...
            //     if(data){
            //         // this.props.removeTrip(this.props.containerIndex);
            //         this.props.refresh();
            //     }
            // };
            // this.context.runProcessing(request, then, "hideTrip");
        }
    }

    runCancelOrNoShow = (reason) => {
        if(this.state.reasonCancel){
            this.runCancel(reason);
        }
        else if(this.state.reasonNoShow){
            this.runNoShow(reason);
        }
    }

    runCancel = (reason) => {
        this.setState({reasonFormOpen: false, reasonCancel: false, reasonNoShow: false});

        console.log("THE CANCEL REASON?", reason);

        const request = () => cancelTrip(this.props.data, reason);
        const then = ({data}) => {
            this.context.sendNotification(!data, data ? "Trip has been canceled": "Error cancelling trip");
            // need to remove the current record

            console.log("CANCEL HAS DATA?", data);

            if(data){
                // this.props.removeTrip(this.props.containerIndex);
                this.props.refresh();
                this.props.onClose();
            }
        };
        this.context.runProcessing(request, then, "cancelTrip");
    }

    getCancelReasonAndSubmit = () => {
        const run = window.confirm("Are you sure you want to mark this trip as lost?");
        if(run){
            this.setState({reasonFormOpen: true, reasonCancel: true, reasonNoShow: false});
        }
    }

    runNoShow = (reason) => {
        this.setState({reasonFormOpen: false, reasonCancel: false, reasonNoShow: false});

        console.log("THE NO SHOW REASON?", reason);

        const request = () => noShowTrip(this.props.data, reason);
        const then = ({data}) => {
            this.context.sendNotification(!data, data ? "Trip has been marked as 'No Show'": "Error marking trip as no show");
            // need to update the current record

            console.log("NO SHOW HAS DATA?", data);

            if(data){
                // this.props.removeTrip(this.props.containerIndex);
                this.props.refresh();
                this.props.onClose();
            }
        };
        this.context.runProcessing(request, then, "noShowTrip");
    }

    getNoShowReasonAndSubmit = () => {
        const run = window.confirm("Are you sure you want to mark this trip as a no-show?");
        if(run){
            this.setState({reasonFormOpen: true, reasonNoShow: true, reasonCancel: false});
        }
    }

    runDelayAnnouncement = () => {
        const request = () => runDelayedAnnouncement(this.props.data);
        const then = ({data}) => {
            this.context.sendNotification(!data, data ? "Delay announcement sent!": "Error sending announcement");
        };
        this.context.runProcessing(request, then, "runDelayedAnnouncement");
    }

    runCancelAnnouncement = () => {
        const request = () => runCancelledAnnouncement(this.props.data);
        const then = ({data}) => {
            this.context.sendNotification(!data, data ? "Lost trip announcement sent!": "Error sending announcement");
        };
        this.context.runProcessing(request, then, "runCancelledAnnouncement");
    }

    runBoarding = () => {
        const request = () => runBoardingAnnouncement(this.props.data);
        const then = ({data}) => {
            this.context.sendNotification(!data, data ? "Boarding announcement sent!": "Error sending announcement");
        };
        this.context.runProcessing(request, then, "runBoardingAnnouncement");
    }

    runLaneChange = () => {
        const request = () => runLaneChangeAnnouncement(this.props.data);
        const then = ({data}) => {
            this.context.sendNotification(!data, data ? "Lane Change announcement sent!": "Error sending announcement");
        };
        this.context.runProcessing(request, then, "runLaneChangeAnnouncement");
    }

    render(){
        return (
            <div className="busops-announcements">
                <div>
                    <h3 className="bottom-space" style={{textAlign:"center"}}>CHANGE STATUS</h3>
                    <div className="option   bottom-space" onClick={this.runHide}>Remove Trip</div>
                    <div className="option   bottom-space" onClick={this.getCancelReasonAndSubmit}>Trip Lost</div>
                    <div className="option   bottom-space" onClick={this.getNoShowReasonAndSubmit}>No Show</div>
                </div>
                <div>
                    <h3 className="bottom-space" style={{textAlign:"center"}}>RUN ANNOUNCEMENT</h3>
                    <div className="option   bottom-space" onClick={this.runBoarding}>Boarding</div>
                    <div className="option   bottom-space" onClick={this.runLaneChange}>Lane Change</div>
                    <div className="option   bottom-space" onClick={this.runDelayAnnouncement}>Delayed</div>
                    <div className="option   bottom-space" onClick={this.runCancelAnnouncement}>Trip Lost</div>
                </div>
                {
                    this.state.reasonFormOpen
                    ? <ReasonForm key={"rf_1"} submitReason={this.runCancelOrNoShow} />
                    : null
                }
            </div>
        );
    }
}